import { gql, TypedDocumentNode } from 'apollo-angular';

import {
  ICreateAndJoinOrganizationInput,
  ICreateAndJoinOrganizationResult,
  IShareOrganizationWithInvestorsInput,
  IShareOrganizationWithInvestorsResult,
  IUpdateOrganizationNameInput,
  IUpdateOrganizationNameResult,
} from '@shared/models/organization';

import { MUTATION_ERROR_FRAGMENT } from '../errors.fragments';
import { ORGANIZATION_FRAGMENT } from '@graphql/fragments/organization.fragment';

export const CREATE_AND_JOIN_ORGANIZATION: TypedDocumentNode<
  ICreateAndJoinOrganizationResult,
  ICreateAndJoinOrganizationInput
> = gql`
  ${MUTATION_ERROR_FRAGMENT}
  ${ORGANIZATION_FRAGMENT}
  mutation createAndJoinOrganization($input: CreateAndJoinOrganizationInput!) {
    createAndJoinOrganization(input: $input) {
      result {
        ...OrganizationFragment
      }
      errors {
        ...ErrorFragment
      }
    }
  }
`;

export const UPDATE_ORGANIZATION_NAME: TypedDocumentNode<
  IUpdateOrganizationNameResult,
  { id: string; input: IUpdateOrganizationNameInput['input'] }
> = gql`
  ${MUTATION_ERROR_FRAGMENT}
  ${ORGANIZATION_FRAGMENT}
  mutation updateOrganizationName(
    $id: ID!
    $input: UpdateOrganizationNameInput!
  ) {
    updateOrganizationName(id: $id, input: $input) {
      result {
        ...OrganizationFragment
      }
      errors {
        ...ErrorFragment
      }
    }
  }
`;

export const SHARE_ORGANIZATION_WITH_INVESTORS: TypedDocumentNode<
  IShareOrganizationWithInvestorsResult,
  IShareOrganizationWithInvestorsInput
> = gql`
  mutation shareOrganizationWithInvestors(
    $input: ShareOrganizationWithInvestorsInput!
  ) {
    shareOrganizationWithInvestors(input: $input)
  }
`;
